export const NEWSBOARD_MESSAGE_FIELD_WYSIWYG_MIN_HEIGHT = 200
